module.exports = __webpack_public_path__ + "media/app/assets/races/night_elf_female-e2789af1a82ba938f5ba9166de5d9bf6.png";